import localforage from 'localforage';
import Url from 'c-url';

// js缓存脚本映射
let scriptMap = {
    swiper: {
        url: '//g.cdn.pengpengla.com/oauthgame/html5/20200227/swiper.min.js'
    },
    protobuf: {
        url: '//h.cdn.pengpengla.com/h5lib/${version}/js/protobuf.js',
        defaultVersion: '3.0.0'
    },
    upFeatureCheck: {
        url: '//h.cdn.pengpengla.com/global/h5lib/${version}/up-feature-check.js',
        defaultVersion: '1.1.1'
    },
    reactWithRouter: {
        url: '//h.cdn.pengpengla.com/global/react/${version}/react16-with-router.min.js',
        defaultVersion: '1.0.5'
    },
    react: {
        url: '//h.cdn.pengpengla.com/global/react/${version}/react16.min.js',
        defaultVersion: '1.0.5'
    },
    nseed: {
        url: '//h.cdn.pengpengla.com/global/h5lib/${version}/nseed.js',
        defaultVersion: '1.0.5'
    },
    zepto: {
        url: '//h.cdn.pengpengla.com/h5lib/${version}/js/zepto.js',
        defaultVersion: '2.1.2'
    }

}

const env = Url.query('env') || 'pro';

const dbname = `uplive/${env}/StaticScriptsCache`;

// ajax加载远程脚本，获取js的内容
function loadOriginScript(url) {
    return new Promise((resolve, reject) => {
        var xmlhttp;
        if (window.XMLHttpRequest){
            //  IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
            xmlhttp=new XMLHttpRequest();
        } else{
            // IE6, IE5 浏览器执行代码
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
        }
        xmlhttp.onreadystatechange=function(){
            if (xmlhttp.readyState==4 && xmlhttp.status==200){
                resolve(xmlhttp.responseText);
            }
        }
        xmlhttp.open("GET",url,true);
        xmlhttp.send();
    })
}

// 根据js字符串 输出script标签
function outputScriptFromStr(name, str) {
    const script = document.createElement('script');
    script.innerHTML = str;
    script.setAttribute('data-name', name);
    script.async = false;
    const head = document.getElementsByTagName('head')[0];
    const body = document.getElementsByTagName('body')[0];
    if (head && scriptMap[name].container !== 'body') {
        head.appendChild(script);
        console.log("name: ", name)
    } else {
        body.appendChild(script);
    }
}

// 输出stript
function outputScript(name) {
    const script = document.createElement('script');
    script.src = name;
    const body = document.getElementsByTagName('body')[0];
    if (name.indexOf('<script') > -1) {
        let placeholder = document.createElement('div');
        placeholder.innerHTML = name;
        let _script = document.createElement('script');
        _script.src = placeholder.firstElementChild.src;
        document.body.appendChild(_script);
        return;
    }
    body.appendChild(script);
}



// 加载一个js脚本
async function loadScript(name) {
    if (!scriptMap[name]) {
        outputScript(name)
        return ;
    }
    const {url} = scriptMap[name] || {};
    const key = dbname + scriptMap[name].url;
    const content = await localforage.getItem(key);
    if (content) {
        try {
            outputScriptFromStr(name, content);
        } catch (error) {
            outputScript(url)
        }
        return true;
    } else {
        return loadOriginScript(url).then(res => {
            localforage.setItem(key, res);
            outputScriptFromStr(name, res);
        }).catch(() => {
            outputScript(url);
        })
    }
}

// 阻塞代码 同步加载 不然js没加载完 但是app.js已运行 会报错


// 加载多个js脚本主入口
async function loadScripts(names) {
    const len = names.length;
    let promises = [];
    for (let index = 0; index < len; index++) {
        const name = names[index];
        promises.push(loadScript(name));
    }
    return Promise.all(promises);
}


// export default loadScripts;

/**
 * 加载js文件入口
 * @param {*} loadKeys 加载的js文件key值数组 具体可见scriptMap
 * @param {*} callbackUrls 加载js文件后 需要加载的文件 通常为app.js 多入口可能不同
 */
function loadJavascripts(loadKeys = [], callbackUrls = []) {
    const keys = [];
    const _scriptMap = {...scriptMap};
    loadKeys.forEach(v => {
        let [name, version] = v.split('@');
        keys.push(name);
        version = version || _scriptMap[name].defaultVersion;
        if (version) {
            _scriptMap[name].url = _scriptMap[name].url.replace('${version}', version);
        }
    })
    scriptMap = _scriptMap;
    loadScripts(keys).then((r) => callbackUrls.forEach(name => outputScript(name)));
}

window.loadJavascripts = loadJavascripts;
export default loadJavascripts;


// WEBPACK FOOTER //
// ./js/loadScript.js